import * as React from 'react';

// @ts-expect-error - imported from .js/.jsx file
import {CompanyTypeIcon} from 'shells/icon/svg/company-type-icon';
import {TwoLine} from 'shells/two-line/two-line';

import type {AccountTypeAutomation as AccountTypeAutomationFragment} from 'nutshell-graphql-types';

import {SalesAutomationCard} from './sales-automation-card';
import {SalesAutomationDraggableCard} from './sales-automation-draggable-card';

type Props = {
    index: number;
    isHidden?: boolean;
    parentId: string;
    accountTypeAutomation: AccountTypeAutomationFragment;
    isDraggable: boolean;
    isDragDisabled?: boolean;
};

export class ClosedLeadAccountAssignmentAutomationCard extends React.PureComponent<Props> {
    render() {
        const Card = this.props.isDraggable ? SalesAutomationDraggableCard : SalesAutomationCard;

        return (
            <Card
                parentId={this.props.parentId}
                isHidden={this.props.isHidden}
                isDragDisabled={this.props.isDragDisabled}
                type='closedLeadAccountTypeAutomations'
                entityId={this.props.accountTypeAutomation.id}
                index={this.props.index}
            >
                <TwoLine
                    icon={CompanyTypeIcon}
                    iconSize={24}
                    topRow='Convert related companies to'
                    bottomRow={this.props.accountTypeAutomation.accountType.name}
                    isLargeWithSmallBottomRow={true}
                />
            </Card>
        );
    }
}
